import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { useNavigate } from 'react-router-dom';
import { Button } from '../../components/ui/button';
import { Sparkles, Calendar, Clock } from 'lucide-react';

export default function Beauty() {
  const navigate = useNavigate();
  const [showBooking, setShowBooking] = useState(false);

  if (showBooking) {
    return (
      <div className="min-h-screen bg-soft-ivory section-padding">
        <div className="max-w-4xl mx-auto">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            className="space-y-8"
          >
            <div className="text-center">
              <h1 className="heading-2 mb-4">Book Your Beauty Ritual</h1>
              <p className="body-text text-dark-cedar/70">Select your preferred date and time</p>
            </div>

            <div className="card-flat p-8 space-y-6">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
                <div>
                  <label className="block text-sm font-semibold text-dark-cedar mb-3">
                    <Calendar className="inline w-4 h-4 mr-2" />
                    Select Date
                  </label>
                  <input
                    type="date"
                    className="w-full p-3 border border-dark-cedar/20 rounded-lg focus:border-tiger-orange focus:ring-2 focus:ring-tiger-orange/20"
                    min={new Date().toISOString().split('T')[0]}
                  />
                </div>

                <div>
                  <label className="block text-sm font-semibold text-dark-cedar mb-3">
                    <Clock className="inline w-4 h-4 mr-2" />
                    Select Time
                  </label>
                  <select className="w-full p-3 border border-dark-cedar/20 rounded-lg focus:border-tiger-orange focus:ring-2 focus:ring-tiger-orange/20">
                    <option>10:00 AM</option>
                    <option>11:00 AM</option>
                    <option>12:00 PM</option>
                    <option>2:00 PM</option>
                    <option>3:00 PM</option>
                    <option>4:00 PM</option>
                  </select>
                </div>
              </div>

              <div>
                <label className="block text-sm font-semibold text-dark-cedar mb-3">
                  Treatment Category
                </label>
                <select className="w-full p-3 border border-dark-cedar/20 rounded-lg focus:border-tiger-orange focus:ring-2 focus:ring-tiger-orange/20">
                  <option>Facial Treatment</option>
                  <option>Skin Analysis</option>
                  <option>LED Light Therapy</option>
                  <option>Microneedling</option>
                  <option>Chemical Peel</option>
                </select>
              </div>

              <div className="bg-desert-sand/30 p-6 rounded-lg">
                <p className="text-sm text-dark-cedar/70 mb-2">Estimated Duration: 60 minutes</p>
                <p className="text-sm text-dark-cedar/70">Price: Contact for consultation</p>
              </div>

              <div className="flex space-x-4">
                <Button onClick={() => setShowBooking(false)} variant="outline" className="flex-1">
                  Back
                </Button>
                <Button className="btn-primary flex-1">Confirm Booking</Button>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-soft-ivory" data-testid="beauty-ritual-page">
      <section className="section-padding">
        <div className="max-w-4xl mx-auto">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            className="text-center mb-12 space-y-6"
          >
            <p className="overline text-tiger-orange">TIGER CIRCLE</p>
            <h1 className="heading-1">Beauty Ritual</h1>
            <p className="body-text text-dark-cedar/80 max-w-2xl mx-auto">
              Discover your personalized beauty treatment plan with our doctor-curated aesthetic services.
            </p>
          </motion.div>

          <div className="space-y-8">
            <div className="card-flat p-8">
              <h2 className="heading-3 mb-6">Available Treatments</h2>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                {[
                  { name: 'Facial Treatment', desc: 'Deep cleansing and nourishment' },
                  { name: 'Skin Analysis', desc: 'Comprehensive skin assessment' },
                  { name: 'LED Light Therapy', desc: 'Advanced rejuvenation' },
                  { name: 'Microneedling', desc: 'Collagen induction therapy' },
                  { name: 'Chemical Peel', desc: 'Texture refinement' },
                  { name: 'Custom Consultation', desc: 'Personalized treatment plan' },
                ].map((treatment, index) => (
                  <motion.div
                    key={index}
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ delay: index * 0.1 }}
                    className="border-l-4 border-tiger-orange bg-desert-sand/20 p-4 rounded-r-lg"
                  >
                    <h3 className="font-inter font-semibold text-dark-cedar mb-1">{treatment.name}</h3>
                    <p className="text-sm text-dark-cedar/70">{treatment.desc}</p>
                  </motion.div>
                ))}
              </div>
            </div>

            <div className="text-center">
              <Button onClick={() => setShowBooking(true)} className="btn-primary">
                <Sparkles className="w-4 h-4 mr-2" />
                Book Beauty Ritual
              </Button>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}